<template>
  <el-date-picker
  v-model="value"
  @input="$emit('model-updated', $event, schema.model)"
  type="date"
  format="dd MMM yyyy"
  class="dateInput"
  placeholder="Choississez une date">
  </el-date-picker>
</template>

<script>
import { abstractField } from "vue-form-generator";
// import datePicker from "vue-bootstrap-datetimepicker";

export default {
  mixins: [abstractField],
  
};
</script>
